"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const formik_1 = require("formik");
const RenderTextField = (props) => {
    const { field: { value, name, onChange, onBlur }, form: { touched, errors, setFieldValue, submitCount }, label, placeholder, inputVariant, submitOnEnter, onInputBlur = () => undefined, ...otherProps } = props;
    const error = (0, formik_1.getIn)(errors, name);
    const touch = (0, formik_1.getIn)(touched, name);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const onKeyDown = (event) => {
        if (!submitOnEnter) {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        }
    };
    const handleOnBlur = (event) => {
        const value = event.target.value.trim();
        setFieldValue(name, value);
        onInputBlur(value);
        onBlur(event);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, null,
            react_1.default.createElement(core_1.Box, { marginBottom: "5px" },
                react_1.default.createElement(core_1.InputLabel, null, label)),
            react_1.default.createElement(core_1.TextField, { id: 'filled-helperText', name: name, variant: inputVariant, fullWidth: true, error: touch && !!error, value: value || '', placeholder: placeholder, onChange: onChange, onBlur: handleOnBlur, onKeyDown: onKeyDown, InputLabelProps: {
                    shrink: true,
                }, ...otherProps }),
            displayErrors && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error)))));
};
RenderTextField.defaultProps = {
    inputVariant: 'filled',
    submitOnEnter: false,
};
RenderTextField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    submitOnEnter: prop_types_1.default.bool,
};
exports.default = RenderTextField;
